'use client'

import { useAllFreightTypes } from '@repo/sdk'
import {
  Button,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  PackagingTypeSelect,
  Separator,
  useSidebar,
} from '@repo/ui'
import { Minus, Plus } from 'lucide-react'
import { Control, useController } from 'react-hook-form'

import { cn } from '../../../lib'

interface Props {
  control: Control<{ goods_description?: string; packaging_type_id: number; pallets: number }>
}

export const PalletsInput = ({ control }: Props) => {
  'use memo'

  const { data: freightTypes } = useAllFreightTypes()
  const { open } = useSidebar()
  const packagingType = useController({ control, name: 'packaging_type_id' })

  const type = freightTypes?.find(type => type.id === Number(packagingType.field.value))

  if (type?.title === 'Other') {
    // ! TO FIX: goods description gets pallets number value, but requires a string
    return (
      <FormField
        control={control}
        name={'goods_description'}
        render={({ field }) => (
          <FormItem className={'w-full'}>
            <FormLabel>Goods description</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    )
  }

  return (
    <FormField
      control={control}
      name={'pallets'}
      render={({ field }) => {
        const handlePlus = () => {
          field.onChange((field?.value ?? 0) + 1)
        }

        const handleMinus = () => {
          if (field?.value && field?.value > 1) {
            field.onChange(field?.value - 1)
          }
        }

        return (
          <FormItem>
            <FormLabel className={'text-card-foreground'}>Pallet quantity (approx.)</FormLabel>
            <FormControl>
              <div className={cn('flex items-center rounded border', open && 'max-lg:flex-col')}>
                <FormField
                  control={control}
                  name={'pallets'}
                  render={({ field }) => (
                    <FormItem className={cn('w-6/12 shrink-0', open && 'max-lg:w-full')}>
                      <FormControl>
                        <div className={'flex items-center'}>
                          <Button
                            className={'shrink-0'}
                            onClick={handleMinus}
                            size={'icon'}
                            type={'button'}
                            variant={'ghost'}
                          >
                            <Minus />
                          </Button>
                          <Input
                            {...field}
                            className={'min-w-10 grow rounded-none border-none px-0 text-center'}
                            placeholder={'0'}
                            type="number"
                          />
                          <Button
                            className={'shrink-0'}
                            onClick={handlePlus}
                            size={'icon'}
                            type={'button'}
                            variant={'ghost'}
                          >
                            <Plus />
                          </Button>
                        </div>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <Separator
                  className={cn('hidden', open && 'max-lg:block')}
                  orientation={'horizontal'}
                />
                {/* @ts-ignore */}
                <PackagingTypeSelect control={control} />
              </div>
            </FormControl>
          </FormItem>
        )
      }}
    />
  )
}
